import { Component, Input } from '@angular/core';
import { UserIssueStatus, UserIssueStatusColors, UserIssueStatusIcons, UserIssueStatusLabels } from 'src/app/interfaces';

@Component({
  selector: 'app-issue-status-chip',
  templateUrl: './issue-status-chip.component.html',
  styleUrls: ['./issue-status-chip.component.scss'],
})
export class IssueStatusChipComponent {
  @Input() status!: UserIssueStatus;
  @Input() size: 'sm' | 'lg' = 'sm';

  labels = UserIssueStatusLabels;
  colors = UserIssueStatusColors;
  icons = UserIssueStatusIcons;
}
